import React, { useContext, useEffect, useState } from "react";
import {
  Row,
  Col,
  Card,
  CardBody,
  CardHeader,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Input,
  FormGroup,
  Label,
} from "reactstrap";
import { Link } from "react-router-dom";
// import * as TBToolkit from "react-bootstrap-table2-toolkit";
// const ToolkitProvider = TBToolkit.default;
// const { Search } = TBToolkit;
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory, {
  PaginationProvider,
  PaginationListStandalone,
  SizePerPageDropdownStandalone,
} from "react-bootstrap-table2-paginator";
import { useMutation, useQuery } from "@apollo/client";
import { ThemeContext } from "src/helpers/themeContext";
import SweetAlert from "react-bootstrap-sweetalert";
import DeleteModal from "src/components/deleteModal/deleteModal";
import "./EmailParserLogs.scss";
import { GET_PARSERLOGS, GET_ORGANISATIONS } from "./emailparserlogs.query";

const EmailParserLogs = () => {
  const [tableData, setTableData] = useState<any>([]);
  const [searchText, setSearchText] = useState("");
  const [deleteModal, setDeleteModal] = useState(false);
  const [success_dlg, setsuccess_dlg] = useState(false);
  const [dynamic_description, setdynamic_description] = useState("");
  const [selectedOrganisationId, setSelectedOrganisationId] = useState<number>(0); // 0 = 'All'
  const [organisations, setOrganisations] = useState<any>([]);
  const Theme = useContext(ThemeContext);

  // Helper function to format date in UK format (DD/MM/YYYY HH:MM)
  const formatUKDateTime = (dateString: string | null): string => {
    if (!dateString) return "—";
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return "—";
    
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    
    return `${day}/${month}/${year} ${hours}:${minutes}`;
  };

  // Helper function to display empty values as '—'
  const displayValue = (value: any): string => {
    if (value === null || value === undefined || value === '') return "—";
    return String(value);
  };

  const columns = [
    {
      dataField: "Id",
      text: "Id",
      sort: true,
      headerStyle: { textAlign: "center" } as React.CSSProperties,
      style: { textAlign: "center" } as React.CSSProperties,
    },
    {
      dataField: "MessageArrived",
      text: "Message Arrived",
      sort: true,
      headerStyle: { textAlign: "center" } as React.CSSProperties,
      style: { textAlign: "center" } as React.CSSProperties,
      formatter: (cell: any) => {
        return new Date(cell).toLocaleString();
      },
    },
    {
      dataField: "ParserType",
      text: "Parser",
      sort: true,
      headerStyle: { textAlign: "center" } as React.CSSProperties,
      style: { textAlign: "center" } as React.CSSProperties,
    },
    {
      dataField: "EmailAddress",
      text: "Email Address",
      sort: true,
      headerStyle: { textAlign: "center" } as React.CSSProperties,
      style: { textAlign: "center" } as React.CSSProperties,
    },
    {
      dataField: "OrgName",
      text: "Org Name",
      sort: true,
      headerStyle: { textAlign: "center" } as React.CSSProperties,
      style: { textAlign: "center" } as React.CSSProperties,
    },
    {
      dataField: "TemplateMessageSent",
      text: "Message Sent Date",
      sort: true,
      headerStyle: { textAlign: "center" } as React.CSSProperties,
      style: { textAlign: "center" } as React.CSSProperties,
      formatter: (cell: any) => {
        return cell === "N/A" ? cell : new Date(cell).toLocaleString();
      },
    },
    {
      dataField: "CustomerReplied",
      text: "Customer Replied Date",
      sort: true,
      headerStyle: { textAlign: "center" } as React.CSSProperties,
      style: { textAlign: "center" } as React.CSSProperties,
      formatter: (cell: any) => {
        return cell === "N/A" ? cell : new Date(cell).toLocaleString();
      },
    },
    {
      dataField: "EmailForwardedAt",
      text: "Email Forwarded",
      sort: true,
      headerStyle: { textAlign: "center" } as React.CSSProperties,
      style: { textAlign: "center" } as React.CSSProperties,
      formatter: (cell: any) => {
        return cell === "N/A" ? cell : new Date(cell).toLocaleString();
      },
    },
    {
      dataField: "ErrorDetails",
      text: "Error Details",
      sort: true,
      headerStyle: { textAlign: "center" } as React.CSSProperties,
      style: { textAlign: "center" } as React.CSSProperties,
    },
    {
      dataField: "S3Identifier",
      text: "Message Identifier",
      sort: true,
      headerStyle: { textAlign: "center" } as React.CSSProperties,
      style: { textAlign: "center" } as React.CSSProperties,
    },
    {
      dataField: "Inbox",
      text: "Inbox",
      sort: true,
      headerStyle: { textAlign: "left" } as React.CSSProperties,
      style: { textAlign: "left" } as React.CSSProperties,
    },
    {
      dataField: "Contact",
      text: "Contact",
      sort: true,
      headerStyle: { textAlign: "center" } as React.CSSProperties,
      style: { textAlign: "center" } as React.CSSProperties,
    },
    {
      dataField: "LeadSource",
      text: "Lead Source",
      sort: true,
      headerStyle: { textAlign: "center" } as React.CSSProperties,
      style: { textAlign: "center" } as React.CSSProperties,
    },
    {
      dataField: "Status",
      text: "Status",
      sort: true,
      headerStyle: { textAlign: "center" } as React.CSSProperties,
      style: { textAlign: "center" } as React.CSSProperties,
    },
    {
      dataField: "FailureReason",
      text: "Failure Reason",
      sort: true,
      headerStyle: { textAlign: "left" } as React.CSSProperties,
      style: { textAlign: "left" } as React.CSSProperties,
    },
  ];

  const handleSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchText(e.target.value);
  };

  const filteredData = tableData.filter((row: any) => {
    return Object.values(row).some((value: any) =>
      String(value).toLowerCase().includes(searchText.toLowerCase())
    );
  });

  const defaultSorted: any = [
    {
      dataField: "Id",
      order: "desc",
    },
  ];

  // Removed row selection checkbox column

  const pageOptions = {
    sizePerPage: 10,
    totalSize: tableData.length,
    custom: true,
    sizePerPageList: [
      { text: "10", value: 10 },
      { text: "25", value: 25 },
      { text: "50", value: 50 },
      { text: "100", value: 100 },
    ],
    showSizePerPage: true,
  };
  // const { SearchBar } = Search;

  // Load organisations
  const { data: orgsData } = useQuery(GET_ORGANISATIONS, {
    fetchPolicy: "no-cache",
  });

  // Load parser logs with filters
  const { data, refetch } = useQuery(GET_PARSERLOGS, {
    fetchPolicy: "no-cache",
    variables: {
      limit: 1000, // Set a reasonable limit
      organisationId: selectedOrganisationId > 0 ? selectedOrganisationId : undefined,
    },
    // Don't skip - allow 'All' (0) to query without org filter
  });

  // Load organisations on mount
  useEffect(() => {
    if (orgsData && orgsData.msgbox_Organisation) {
      setOrganisations(orgsData.msgbox_Organisation);
      // Don't auto-select - default is 'All' (0)
    }
  }, [orgsData]);

  // Process parser logs data
  useEffect(() => {
    if (data && data.msgbox_EmailParserLog) {
      const tmpData = data.msgbox_EmailParserLog.map((item: {
        EmailParserLogId: number;
        MessageArrived: string;
        ParserType: string | null;
        EmailAddress: string | null;
        OrganisationName: string | null;
        TemplateMessageSent: string | null;
        CustomerReplied: string | null;
        EmailForwardedAt: string | null;
        ErrorDetails: string | null;
        S3Identifier: string | null;
        InboxName: string | null;
        ContactMobileMasked: string | null;
        LeadSource: string | null;
        SendStatus: string | null;
        SendFailureReason: string | null;
      }) => {
        return {
          Id: item.EmailParserLogId,
          MessageArrived: item.MessageArrived.replace("T", " "),
          ParserType: item.ParserType,
          EmailAddress: item.EmailAddress,
          OrgName: item.OrganisationName,
          TemplateMessageSent: item.TemplateMessageSent
            ? item.TemplateMessageSent.replace("T", " ")
            : "N/A",
          CustomerReplied: item.CustomerReplied
            ? item.CustomerReplied.replace("T", " ")
            : "N/A",
          EmailForwardedAt: item.EmailForwardedAt
            ? item.EmailForwardedAt.replace("T", " ")
            : "N/A",
          ErrorDetails: item.ErrorDetails,
          S3Identifier: item.S3Identifier,
          Inbox: displayValue(item.InboxName),
          Contact: displayValue(item.ContactMobileMasked),
          LeadSource: displayValue(item.LeadSource),
          Status: displayValue(item.SendStatus),
          FailureReason: displayValue(item.SendFailureReason),
        };
      });
      setTableData(tmpData);
    } else {
      setTableData([]);
    }
  }, [data]);

  const refetchData = () => {
    refetch();
  };

  const handleDelete = async (log: any) => {
    setDeleteModal(false);
    // Add your delete mutation here
    setsuccess_dlg(true);
    setdynamic_description(
      "Item will not be available to the user now, it will be permanently deleted in 60 days"
    );
    refetchData();
  };

  const handleOrganisationChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSelectedOrganisationId(Number(e.target.value));
  };

  return (
    <React.Fragment>
      {success_dlg ? (
        <SweetAlert
          success
          title={Theme.name}
          onConfirm={() => {
            setsuccess_dlg(false);
          }}
        >
          {dynamic_description}
        </SweetAlert>
      ) : null}
      <DeleteModal
        isOpen={deleteModal !== false}
        cancel={() => setDeleteModal(false)}
        submit={() => handleDelete(deleteModal)}
      />

      <Card>
        <CardHeader>
          <Row>
            <Col md={6}>
              <div className="mb-3">
                <h4 className="card-title">Email Parser Logs</h4>
              </div>
            </Col>
            <Col md={6}>
              <div className="d-flex flex-wrap align-items-start justify-content-md-end mt-2 mt-md-0 gap-2 mb-3">
                <div>
                  <Link to="#" className="btn btn-light" onClick={refetchData}>
                    <i className="uil uil-refresh me-1"></i> Refresh
                  </Link>
                </div>
              </div>
            </Col>
          </Row>
        </CardHeader>
        <CardBody>
          <PaginationProvider pagination={paginationFactory(pageOptions)}>
            {({ paginationProps, paginationTableProps }) => (
              <React.Fragment>
                <Row className="mb-2">
                  <Col md="4">
                    <div className="search-box me-2 mb-2 d-inline-block">
                      <div className="position-relative">
                        <Input
                          type="text"
                          className="form-control"
                          placeholder="Search..."
                          value={searchText}
                          onChange={handleSearch}
                        />
                        <i className="bx bx-search-alt search-icon" />
                      </div>
                    </div>
                  </Col>
                  <Col md="4">
                    <div className="mb-2">
                      <Input
                        type="select"
                        value={selectedOrganisationId}
                        onChange={handleOrganisationChange}
                      >
                        <option value={0}>All</option>
                        {organisations.map((org: any) => (
                          <option key={org.OrganisationId} value={org.OrganisationId}>
                            {org.Name}
                          </option>
                        ))}
                      </Input>
                    </div>
                  </Col>
                </Row>

                <Row>
                  <Col xl="12">
                    <div className="table-responsive">
                      <BootstrapTable
                        bordered={false}
                        striped={false}
                        defaultSorted={defaultSorted}
                        classes="table align-middle table-nowrap"
                        headerWrapperClasses="thead-dark"
                        headerClasses="table-dark"
                        {...paginationTableProps}
                        keyField="Id"
                        columns={columns}
                        data={filteredData}
                      />
                    </div>
                  </Col>
                </Row>

                <Row className="align-items-md-center mt-30">
                  <Col className="inner-custom-pagination d-flex">
                    <div className="d-inline">
                      <SizePerPageDropdownStandalone {...paginationProps} />
                    </div>
                    <div className="text-md-right ms-auto">
                      <PaginationListStandalone {...paginationProps} />
                    </div>
                  </Col>
                </Row>
              </React.Fragment>
            )}
          </PaginationProvider>
        </CardBody>
      </Card>
    </React.Fragment>
  );
};

export default EmailParserLogs;
